import React from 'react';
import './ServicesFull.css';

const ServicesFull = () => {
  const services = [
    {
      number: '01',
      title: 'Automation Solutions',
      description: 'Automation-driven BOTs that streamline vendor verification, compliance checks, and bulk credential validation across government datasets.',
      approach: ['Faster and more accurate verifications', 'Reduced manual errors', 'Improved compliance readiness', 'Scalable automation tailored to client workflows']
    },
    {
      number: '02',
      title: 'IT Audit & Information Security',
      description: 'We evaluate and strengthen information systems to ensure resilience, reliability, and compliance with global standards.',
      capabilities: ['Information Security Controls Review', 'ISO 27001 (ISMS) Implementation Assistance', 'IT General & Application Controls Audit', 'IT SOX Audit', 'Data Migration Audit', 'Business Continuity (BCP/DR) Evaluation'],
      note: 'Our expertise ensures that technology risks are identified, mitigated, and managed effectively.'
    },
    {
      number: '03',
      title: 'Accounting & Offshore Accounting',
      description: 'Whether for domestic businesses or global clients, we deliver reliable, accurate, and audit-ready accounting services.',
      capabilities: ['Bookkeeping & General Ledger Maintenance', 'Daily/Weekly/Monthly Transaction Processing', 'AP/AR Management', 'Bank Reconciliation', 'Payroll Support', 'Year-End Closing & Coordination', 'MIS Reporting (Cash Flow, KPIs, Budget vs Actuals)'],
      offshore: {
        title: 'Offshore Accounting Expertise',
        description: 'We support US clients with end-to-end accounting built on efficiency, security, and next-day review advantages.',
        process: ['Client onboarding & SOP review', 'QuickBooks / Zoho Books setup', 'Parallel accounting & trial runs', 'Daily/weekly reconciliations', 'Monthly reports and CPA collaboration', 'Encrypted backups & quarterly security audits']
      },
      approach: ['Cost efficiency without compromise', 'Audit-rich perspective for better accuracy', 'Scalable team of trained professionals']
    },
    {
      number: '04',
      title: 'Data Analytics & Business Intelligence',
      description: 'Transforming data into meaningful insights for better strategic decisions.',
      capabilities: ['Financial & Operational Analytics', 'BI Dashboards & KPI Monitoring', 'Predictive Modelling', 'Trend, Ratio & Variance Analysis', 'Exception & Anomaly Detection', 'Automated Reporting Systems'],
      note: 'We help clients identify risks early, improve performance, and unlock growth opportunities.'
    },
    {
      number: '05',
      title: 'Audit & Assurance',
      description: 'We provide comprehensive audit and assurance services with an emphasis on independence, professionalism, and technical accuracy. Our audit methodologies align with ICAI Standards of Auditing and industry best practices.',
      capabilities: ['Statutory Audits', 'Internal Audits', 'Management & Operational Audits', 'Compliance & Process Audits', 'Risk-Based Audits', 'SOP & Internal Control Evaluations'],
      approach: ['Structured audit planning', 'Data-driven insights', 'Strong documentation & quality review', 'Transparent communication throughout the engagement']
    },
    {
      number: '06',
      title: 'Tax Advisory',
      description: 'We offer tailored, practical, and compliance-focused tax solutions for individuals, corporates, and organisations across sectors.',
      capabilities: ['Tax Planning & Advisory', 'Corporate and Individual Tax Compliance', 'Representation Before Authorities', 'Transaction & Business Structuring', 'Capital Gains and Business Tax Analysis'],
      note: 'We help clients manage tax risks, ensure compliance accuracy, and optimise tax outcomes.'
    }
  ];

  return (
    <section id="services" className="services-full section">
      <div className="container">
        <div className="section-header center animate-on-scroll">
          <span className="section-label">Our Expertise</span>
          <h2>Services</h2>
        </div>

        {services.map((service, index) => (
          <div key={index} className="service-detail animate-on-scroll">
            <div className="service-detail-header">
              <div className="service-number">{service.number}</div>
              <h3>{service.title}</h3>
            </div>
            <p>{service.description}</p>
            
            {service.capabilities && (
              <div className="service-capabilities">
                <h4>{service.number === '03' ? 'Core Services:' : service.number === '02' ? 'Services Offered:' : 'Our Capabilities Include:'}</h4>
                <ul>
                  {service.capabilities.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {service.offshore && (
              <div className="highlight-box">
                <h4>{service.offshore.title}</h4>
                <p>{service.offshore.description}</p>
                <h5>Our Process Includes:</h5>
                <ul>
                  {service.offshore.process.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {service.approach && (
              <div className="service-approach">
                <h4>{service.number === '06' ? 'Benefits:' : service.number === '03' ? 'Why Choose Us:' : 'Our Approach:'}</h4>
                <ul>
                  {service.approach.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {service.note && <p className="service-note">{service.note}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesFull;
